import { get } from 'lodash'
import { ANCHOR, ANCHOR_LINK_MAP } from '../constants'
import Section from '../../Common/NewDashboard/Section/Section'
import Layout from '../Layout'
import SidebarLayout from '../Layout/Sidebar'
import MainLayout from '../Layout/Main'
import Sidebar from './Sidebar'
import SaleStat from './SaleStat'
import BestsellerRanking from './BestsellerRanking'
import PageViewsAnalysis from './PageViewsAnalysis'
import DashboardReminder from './DashboardReminder'
import { sendGaPv, sendGaClick } from '../utils/ga'
import SalesPerformance from './SalesPerformance'

const gaPageType = 'seller_dashboard'

const SECTIONS = [
  {
    anchor: ANCHOR_LINK_MAP[ANCHOR.SALES_PERFORMANCE],
    component: SalesPerformance
  },
  {
    anchor: ANCHOR_LINK_MAP[ANCHOR.SALE_STAT],
    component: SaleStat
  },
  {
    anchor: ANCHOR_LINK_MAP[ANCHOR.BESTSELLER_RANKING],
    component: BestsellerRanking
  },
  {
    anchor: ANCHOR_LINK_MAP[ANCHOR.PAGE_VIEWS_ANALYSIS],
    component: PageViewsAnalysis
  }
]

const Page = ({ actions, page }) => {
  const user = get(page, 'user', {})
  sendGaPv(gaPageType, user)

  const onGaClick = (label) => {
    sendGaClick(label, user)
  }

  return (
    <Layout>
      <SidebarLayout>
        <Sidebar onGaClick={onGaClick} />
      </SidebarLayout>
      <MainLayout>
        {SECTIONS.map((section, index) => {
          return (
            <Section
              key={index}
              page={page}
              actions={actions}
              onGaClick={onGaClick}
              {...section}
            />
          )
        })}
        <DashboardReminder />
      </MainLayout>
    </Layout>
  )
}

export default Page
